import css from 'styled-jsx/css';

export const staticStyles = css.global`
  .TransferWarning {
    max-width: 700px;
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 12px;
    border-radius: 8px;
    background: rgba(242, 178, 51, 0.1);

    &__icon-wrapper {
      color: #f2b233;

      svg {
        width: 40px !important;
        height: 40px !important;
      }
    }

    span {
      font-size: 14px;
      font-weight: 500;
    }
  }
`;
